import { useTranslation } from 'react-i18next';

// Import assets
import { ReactComponent as DotIcon } from 'assets/icons/ic_list_dot.svg';
import { ReactComponent as CheckIcon } from 'assets/icons/ic_list_check.svg';

// Import styles
import { HintWrapper, Hint } from './styles';

// Import types
import type { PasswordHint } from 'types/views/form';

type Props = { hints: PasswordHint[]; value: string; isError: boolean };

export const PasswordHints = ({ hints, value, isError }: Props) => {
	const { t } = useTranslation();

	const checkIsRequirementFulfilled = (regex: RegExp) => regex.test(value);

	return (
		<>
			{hints.map(({ regex, hint }) => {
				const isFulfilled = checkIsRequirementFulfilled(regex);

				return (
					<HintWrapper key={hint} isFulfilled={isFulfilled} isError={isError}>
						{isFulfilled ? <CheckIcon /> : <DotIcon />}
						<Hint>{t(hint)}</Hint>
					</HintWrapper>
				);
			})}
		</>
	);
};
